import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, memo, useMemo } from 'react';
import Icons from '../../Elements/Icons/index.js';
import { SubSection, Title } from './components/index.js';
import { useExpandCollapse } from './hooks/index.js';
import { ItemsWrapper, SectionWrapper } from './styled.js';
const SectionComponent = memo(forwardRef(function SectionComponent(props, ref) {
    const { children, id, className, dataTestId, title, tooltip, tag, actions, icon, iconPosition, onIconClick, height, expanded, inner, itemsStyles, showExpandIcon, } = props;
    const { getCollapseProps, isExpanded } = useExpandCollapse(expanded);
    const hasTitle = !!(title || actions);
    const hasFixedHeight = height !== undefined;
    const expandIcon = useMemo(() => (showExpandIcon ? _jsx(Icons.Chevron, { align: isExpanded ? 'bottom' : 'top' }) : null), [showExpandIcon, isExpanded]);
    const finalIcon = icon ?? expandIcon;
    return (_jsxs(SectionWrapper, { id: id, className: className, height: height, $inner: inner, ref: ref, "data-testid": dataTestId, children: [hasTitle && (_jsx(Title, { title: title, tooltip: tooltip, tag: tag, actions: actions, icon: finalIcon, iconPosition: iconPosition, onIconClick: onIconClick })), _jsx(ItemsWrapper, { ...getCollapseProps(), $hasTitle: hasTitle, $isExpanded: isExpanded, $hasFixedHeight: hasFixedHeight, $customStyles: itemsStyles, children: children })] }));
}));
export const Section = Object.assign(SectionComponent, {
    Item: SubSection,
});
